import { TmsEventType, } from '../DataLayer.types';
import DataLayerBaseEvent from './DataLayerBaseEvent';
export default class ExperienceImpressionEvent extends DataLayerBaseEvent {
    update(tms, payload, errorHandler) {
        this.updateDataLayer(tms, TmsEventType.link, 'experience_impression', payload, errorHandler);
    }
}
//# sourceMappingURL=ExperienceImpressionEvent.js.map